import getErrorMessageFromWacAttachmentStatus from './getErrorMessageFromWacAttachmentStatus';
import getWacInfo from '../services/getWacInfo';
import WacUrlInfo from '../types/WacUrlInfo';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import WacAttachmentStatus from 'owa-service/lib/contract/WacAttachmentStatus';
import WacAttachmentType from 'owa-service/lib/contract/WacAttachmentType';
import strings from 'owa-strings/owa-mail-strings';

export default async function getWacInfoForSharePointLink(
    linkUrl: string,
    shouldGrantAccess: boolean = false
): Promise<WacUrlInfo> {
    let wacAttachmentTypeResponse: WacAttachmentType;
    try {
        wacAttachmentTypeResponse = await getWacInfo(
            linkUrl,
            AttachmentDataProviderType.OneDrivePro,
            shouldGrantAccess
        );
    } catch (error) {
        throw {
            errorMessage: strings.errorGetWacUrl,
            error: error,
        };
    }

    if (wacAttachmentTypeResponse.Status === WacAttachmentStatus.Success) {
        return {
            wacUrl: wacAttachmentTypeResponse.WacUrl,
            bootScriptUrl: wacAttachmentTypeResponse.BootScriptUrl,
            wopiSrcUrl: wacAttachmentTypeResponse.WopiSrcUrl,
            accessToken: wacAttachmentTypeResponse.AccessToken,
            token: wacAttachmentTypeResponse.Token,
        };
    } else {
        const errorMessage = getErrorMessageFromWacAttachmentStatus(
            wacAttachmentTypeResponse.Status
        );
        throw {
            errorMessage: errorMessage,
            error: new Error(
                `GetWacAttachmentInfo failed with status: ${wacAttachmentTypeResponse.Status}`
            ),
        };
    }
}
